'use client';

import { useEffect, useRef } from 'react';
import { apiUrl } from '@/lib/api-base';
import { useAuthStore } from '@/stores/authStore';

/**
 * Top-level handler for SBAA app-subdomain links carrying a
 * short-lived `login_token` query param. The token is minted by the
 * WhatsApp /account slash command for users who have no Google
 * identity; visiting the URL exchanges it for a regular session JWT
 * so the user lands signed in without needing OAuth.
 */
export function LoginTokenExchange() {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    const params = new URLSearchParams(window.location.search);
    const token = params.get('login_token');
    if (!token) return;
    handled.current = true;

    (async () => {
      try {
        const resp = await fetch(apiUrl('/api/v1/auth/token-login'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        if (resp.ok) {
          const data = await resp.json();
          useAuthStore.setState({
            sessionToken: data.token,
            aurigaUid: data.auriga_uid,
            userEmail: data.email || null,
            hasHydrated: true,
          });
        }
      } catch {
        // Best-effort: on failure we just leave the user signed out.
      } finally {
        params.delete('login_token');
        const qs = params.toString();
        const next = window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash;
        window.history.replaceState(null, '', next);
      }
    })();
  }, []);

  return null;
}
